import type React from 'react';
import { Icon } from '@iconify/react';

type FieldIconProps = {
    /** An Iconify icon name, e.g. `solar:shop-2-linear`. */
    icon: string;
};

/**
 * A decorative icon at the start of a HeroUI `Select.Trigger`, in the field's
 * muted tone (bos-app#138). `InputGroup` gives the icons in its prefix and
 * suffix that tone (`text-field-placeholder`) itself, but a `Select` trigger
 * has no slot or prop for a leading icon. This is the one place that sets the
 * same token there, so the branch field's Views carry no colour. It is still a
 * colour through `className`, which rulebook §6 allows for no pattern of this
 * kind, so the gap is in the migration register in .agents/frontend.md.
 */
export const FieldIcon: React.FC<FieldIconProps> = ({ icon }) => (
    <Icon aria-hidden className="shrink-0 text-field-placeholder" icon={icon} />
);
